import React from 'react';
import { useUserContext } from '../context/user';
import { UserInfo } from '../models/IUserDetails';
import { AppHeader } from '@nike/eds';
import { LanguageMenu } from './LanguageMenu'
import { Profile } from './profile';
import { CommandBar } from './command-bar/command-bar'
import { Footer } from "./footer/footer";
import { useLocation } from 'react-router-dom';

export const Layout: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const userInfo: UserInfo = useUserContext();
  const location=useLocation();

  const isAuthenticated = !!userInfo?.passplayUser && location.pathname !== '/login';

  return (
    <>
      <AppHeader
        className="app-header"
        isDark
        appName=""
        logoSlot={<LanguageMenu />}
        avatarSlot={<Profile userInfo={isAuthenticated?userInfo:undefined} />}
        commandBarSlot={isAuthenticated ? <CommandBar /> : undefined}
      />
      <div className="header-break"></div>
      <div className='eds-spacing--mb-40 main-content-div'>{children}</div>
      {isAuthenticated ? <Footer /> : undefined}
    </>
  );
};
